import React from 'react';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { HashLink as LinkHash } from 'react-router-hash-link';

// Own constants/actions/components
import {
  OUTSESION,
  LOGIN_URL,
  REGISTER_LINK,
} from 'constants/Constants';

const MenuMobile = (props) => {
  const { session } = props;

  const handleMenu = (event) => {
    event.preventDefault();
    const elem = document.querySelectorAll('.menu-container')[0];
    elem.classList.toggle('collapse');
  };

  const handleOutSesion = () => {
    Cookies.remove('frontSession');
    window.location.href = OUTSESION;
  };

  const renderButtonsSessionActive = () => {
    return (
      <div>
        <button type="button" className="btn btn-secondary btn-sm btn-size-override" onClick={handleOutSesion}>
          Cerrar sesión
        </button>
      </div>
    );
  };

  const renderButtonsNotSession = () => {
    return (
      <div>
        <a className="btn btn-secondary-dark btn-sm btn-size-override" href={LOGIN_URL}>
          Inicia sesión
        </a>
        <a className="btn btn-primary-dark btn-sm btn-size-override" href={REGISTER_LINK}>
          Inscríbete
        </a>
      </div>
    );
  };

  return (
    <div className="nav-menu-responsive d-block d-lg-none d-xl-none">
      <div className="main-bar">
        <div>
          <a className="menu-toggle" href="/" onClick={handleMenu}>
            <i className="fas fa-bars" />
          </a>
        </div>
        {
          session ? renderButtonsSessionActive() : renderButtonsNotSession()
        }
      </div>
      <div className="menu-container collapse">
        <div className="menu-content level-1">
          <div className="menu-item">
            <div className="menu-item-label">
              <Link to="/">
                <i className="fas fa-home" />
              </Link>
            </div>
          </div>
          <div className="menu-item">
            <div className="menu-item-label">
              <LinkHash to="/home/#experiencias">
                Experiencias
              </LinkHash>
            </div>
          </div>
          <div className="menu-item">
            <div className="menu-item-label">
              <LinkHash to="/home/#experiencias-recomendadas">
                Experiencias recomendadas
              </LinkHash>
            </div>
          </div>
          <div className="menu-item">
            <div className="menu-item-label">
              <Link to="/revive-experiencias">
                Revive Experiencias
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MenuMobile.propTypes = {
  session: PropTypes.bool.isRequired,
};

export default MenuMobile;
